// extracted by css-extract-rspack-plugin
var _1 = "asterisk__Nta97";
var _2 = "error__qZZV3";
var _3 = "flex-container__TzZ6w";
var _4 = "text__MgCAR";
export { _1 as "asterisk", _2 as "error", _3 as "flex-container", _4 as "text" }
export default { "asterisk": _1, "error": _2, "flex-container": _3, "text": _4 }
